import ReactGA4 from 'react-ga4';

/**
 * A1GA
 *
 * This is just a leftover used for simplizity. It was used to initialize both GA packages at the same time.
 * After all the class to function migration is done, we should refactor the code to use the GA4 package directly.
 * Otherwise there will probably be too many conflicts.
 *
 * So: @TODO refactor the code to use GA4 directly and remove this file
 *
 * Note: Not all function and parameters have been implemented
 * only what we are currently using...
 */


/**
 * Initializes both packages
 * Note: only the debug/testMode parameter is enabled as of now
 *
 * @param options Object
 * @returns void
 */
const initialize = function initialize(options) {
    // Note: Keeping the following around, in case we will ever search for the old Tracking ID
    // in the codebase, to find out where it was used.
    /* ReactGA.initialize('UA-5235184-4', {
        debug: options.debug || false,
    }); */

    // The public website uses its consent-controlled GTM container for GA4.
    // Webviews keep their existing analytics initialization.
    if (typeof window === 'undefined' || window.__A1_WEBSITE__) return;

    ReactGA4.initialize('G-Y9VG6CFX18', {
        testMode: options.debug || false,
    });
};

/**
 * Log pageview
 *
 * @param name String
 * @returns void
 */
const pageview = function pageview(path) {
    if (typeof window !== 'undefined' && window.__A1_WEBSITE__ && !window.A1Consent?.allowed()) return;

    ReactGA4.send({ hitType: 'pageview', page: path });
};

/**
 * Log event
 *
 * @param options Object
 * @returns void
 */
const event = function event(options) {
    if (typeof window !== 'undefined' && window.__A1_WEBSITE__ && !window.A1Consent?.allowed()) return;

    ReactGA4.event(options);
};


export default {
    initialize,
    pageview,
    event,
};
